import { PayloadAction, createAction, createReducer } from "@reduxjs/toolkit";

import { STORES } from "store/types";

import { GridMode } from "./types";

export interface EmissionsState {
  gridMode: GridMode;
}

// define action types
export const setGridMode = createAction<GridMode>(
  `${STORES.emissions}/setGridMode`
);

// create reducer
const emissionsReducer = createReducer<EmissionsState>(
  {
    gridMode: GridMode.LOADING,
  },
  (builder) => {
    builder.addCase(setGridMode, (state, action: PayloadAction<GridMode>) => {
      state.gridMode = action.payload;
    });
  }
);

export default emissionsReducer;
